import { defineStyleConfig as l } from "@chakra-ui/react";
import e from "./input.mjs";
var i, t;
const d = l({
  baseStyle: {
    ...(i = e.baseStyle) == null ? void 0 : i.field,
    paddingY: "8px",
    minHeight: "80px",
    lineHeight: "short",
    verticalAlign: "top"
  },
  sizes: {
    sm: e.sizes.sm.field,
    md: e.sizes.md.field
  },
  variants: {
    outline: e.variants.outline.field,
    filled: e.variants.filled.field
  },
  defaultProps: {
    size: (t = e.defaultProps) == null ? void 0 : t.size,
    variant: "outline"
  }
});
export {
  d as default
};
